import { Button, Flex } from "antd";
import useWepapp from "../hook/useWepapp";
import { useMediaQuery } from "react-responsive";
const { Outlet } = require("react-router-dom")

const HistoryComponent = ({
    p9 = "",
    cardHis = () => { },
    navBar = () => { },
}) => {
    const { goToMenu = () => { } } = useWepapp()
    const isPortrait = useMediaQuery({ orientation: 'portrait' })
    return (
        <Flex vertical style={{
            maxHeight: '100vh'
        }}>
            <Flex vertical style={{ height: "90vh", display: "flex", flexDirection: "column", backgroundColor: "#FCF9F6", padding: "5vh", gap: "2vh" }} >
                <Flex vertical style={{ color: "#5E5E5E", fontSize: isPortrait ? "2vh" : "2vw" }}>
                    <span >{p9}</span>
                </Flex>
                {cardHis()}
            </Flex>

            {navBar()}
        </Flex>

    )
}
export default HistoryComponent;